const AUTH_TOKEN_LOCAL_STORAGE_KEY = 'JWT_MIDDLEWARE:authToken';

export const getLocalStorageToken = () => {
  try {
    const jsonString = globalThis.localStorage.getItem(AUTH_TOKEN_LOCAL_STORAGE_KEY);
    return JSON.parse(jsonString);
  } catch (_error) {
    return null;
  }
};

export const setLocalStorageToken = token => {
  const jsonString = JSON.stringify(token);
  globalThis.localStorage.setItem(AUTH_TOKEN_LOCAL_STORAGE_KEY, jsonString);
};

export const deleteLocalStorageToken = () => globalThis.localStorage.removeItem(AUTH_TOKEN_LOCAL_STORAGE_KEY);
